module.exports = __webpack_public_path__ + "static/media/students-in-the-arctic--resized.21f220f9.jpg";